import { render, staticRenderFns } from "./deleteGold.vue?vue&type=template&id=4b9d5662&scoped=true"
import script from "./deleteGold.vue?vue&type=script&lang=js"
export * from "./deleteGold.vue?vue&type=script&lang=js"
import style0 from "./deleteGold.vue?vue&type=style&index=0&id=4b9d5662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d5662",
  null
  
)

export default component.exports